/**
 * Runtime contract for live financial data placeholder tags used in formulas.
 *
 * @remarks
 * Web and admin formula tooling iterate over this string enum to validate and
 * insert tags. Keep the declaration order stable so those menus and validators
 * preserve the historical grouping from the retired `HelloCashflowDomain`
 * TextGeneration bridges.
 *
 * @see packages/domain/src/textGeneration/liveDataTag.test.ts
 * @see apps/admin/src/__tests__/utils/insertFormulaHelpers.test.ts
 * @see apps/admin/src/__tests__/utils/insertFormulaValidation.test.ts
 * @see apps/web/src/__tests__/regression/hooks/useCustomFormulas.test.tsx
 */
export enum DataTagType {
  REVENUE_LATEST_MONTH = "REVENUE_LATEST_MONTH",
  REVENUE_PREVIOUS_MONTH = "REVENUE_PREVIOUS_MONTH",
  REVENUE_PREVIOUS_12_MONTHS = "REVENUE_PREVIOUS_12_MONTHS",
  REVENUE_SAME_MONTH_LAST_YEAR = "REVENUE_SAME_MONTH_LAST_YEAR",
  EXPENSES_LATEST_MONTH = "EXPENSES_LATEST_MONTH",
  EXPENSES_PREVIOUS_MONTH = "EXPENSES_PREVIOUS_MONTH",
  EXPENSES_SAME_MONTH_LAST_YEAR = "EXPENSES_SAME_MONTH_LAST_YEAR",
  PROFIT_LATEST_MONTH = "PROFIT_LATEST_MONTH",
  PROFIT_PREVIOUS_MONTH = "PROFIT_PREVIOUS_MONTH",
  PROFIT_SAME_MONTH_LAST_YEAR = "PROFIT_SAME_MONTH_LAST_YEAR",
  DIRECT_COSTS_LATEST_MONTH = "DIRECT_COSTS_LATEST_MONTH",
  DIRECT_COSTS_PREVIOUS_MONTH = "DIRECT_COSTS_PREVIOUS_MONTH",
  DIRECT_COSTS_PREVIOUS_12_MONTHS = "DIRECT_COSTS_PREVIOUS_12_MONTHS",
  // Budget tags follow the historical formula menu grouping; tests assert order.
  REVENUE_BUDGET_LATEST_MONTH = "REVENUE_BUDGET_LATEST_MONTH",
  REVENUE_BUDGET_PREVIOUS_MONTH = "REVENUE_BUDGET_PREVIOUS_MONTH",
  REVENUE_BUDGET_SAME_MONTH_LAST_YEAR = "REVENUE_BUDGET_SAME_MONTH_LAST_YEAR",
  EXPENSES_BUDGET_LATEST_MONTH = "EXPENSES_BUDGET_LATEST_MONTH",
  EXPENSES_BUDGET_PREVIOUS_MONTH = "EXPENSES_BUDGET_PREVIOUS_MONTH",
  EXPENSES_BUDGET_SAME_MONTH_LAST_YEAR = "EXPENSES_BUDGET_SAME_MONTH_LAST_YEAR",
  PROFIT_BUDGET_LATEST_MONTH = "PROFIT_BUDGET_LATEST_MONTH",
  PROFIT_BUDGET_PREVIOUS_MONTH = "PROFIT_BUDGET_PREVIOUS_MONTH",
  PROFIT_PREVIOUS_12_MONTHS = "PROFIT_PREVIOUS_12_MONTHS",
  PROFIT_BUDGET_SAME_MONTH_LAST_YEAR = "PROFIT_BUDGET_SAME_MONTH_LAST_YEAR",
}
